<!--试剂管理页面免费版-->
<template>
  <div class="">
    <ZnBreadcrumb>
      <div slot="rightbutton">

        <el-badge :value="showBookingNum" class="item" v-show="showBookingBtn" >
          <el-button  @click="bookingClick()" size="small" class="basic-btn" v-show="showBookingBtn" style="width: 78px;margin-right: 30px;">我的领用</el-button>
        </el-badge>

        <el-badge :value="showChooseNum" class="item" v-show="showChooseBtn" >
          <el-button  @click="chooseDialog()" size="small" class="basic-btn" v-show="showChooseBtn" style="width: 78px;margin-right: 30px;">我的预选</el-button>
        </el-badge>

        <el-button
          type="primary"
          @click="addReagentVisible = true"
          size="small"
          class="basic-btn" >新增试剂</el-button >
      </div>
    </ZnBreadcrumb>
    <div
      class="main-content"
      v-title
      data-title="试剂管理_试剂采购库存管理系统"
    >
      <div class="search-type" style="padding-bottom: 10px">
        <div class="searchLine">
          <ul class="clearfix" style="padding-left: 0px">
            <li>
              <el-tooltip content="试剂名/CAS号/试剂编号/品牌/订单编号/最近操作人" placement="top" effect="light">
                <input
                    type="text"
                    v-model="searchData.casNo"
                    placeholder="请输入关键字"
                    style="width: 150px"
                    @keyup.enter="reagentList()"
                />
              </el-tooltip>


              <el-select v-model="selectValue" size="small" @change="reagentList"
                         placeholder="试剂状态" style="margin-left: 20px;">
                <el-option label="全部" value="" style="color: #606266;font-size: 14px;"/>
                <el-option label="订购中" value="8" style="color: #606266;font-size: 14px;"/>
                <el-option label="待编辑" value="0" style="color: #606266;font-size: 14px;"/>
                <el-option label="在库" value="2" style="color: #606266;font-size: 14px;"/>
                <el-option label="已取出" value="4" style="color: #606266;font-size: 14px;"/>
                <el-option label="盘点中" value="9" style="color: #606266;font-size: 14px;"/>
                <el-option label="盘点遗失" value="10" style="color: #606266;font-size: 14px;"/>
              </el-select>
            </li>



              <li style="margin-left: 20px;">
                <el-tooltip content="此框可支持模糊搜索" placement="top" effect="light">
                  <div class="locationClass">
                    <el-autocomplete
                        ref="cabAutoRef"
                        class="input-with-select"
                        v-model="searchData.originalLocation"
                        :fetch-suggestions="queryMatchCab"
                        :clearable="true"
                        :hide-loading="false"
                        @clear="setBlur"
                        placeholder="请输入位置信息"
                        @select="handleCabSelect">
                      <el-select v-model="searchData.locationType" slot="prepend" placeholder="请选择类型"
                                 style="margin-left: 0px;">
                        <el-option label="系统位置" value="1" style="color: #606266;font-size: 14px;"></el-option>
                        <el-option label="原始位置" value="2" style="color: #606266;font-size: 14px;"></el-option>
                      </el-select>
                    </el-autocomplete>
                  </div>
                </el-tooltip>
              </li>
              <li style="padding-top: 5px;">
                <label style="color: #606266; font-size: 14px;width: 65px;margin-left: 20px;">剩余剂量</label>
                <button
                    ref="on"
                    style="
                      width: 55px;
                      height: 20px;
                      color: black;
                      display: inline-block;
                      border-radius: 4px;
                      line-height: 1;
                      text-align: center;
                      margin-left: 10px;
                    "
                    @click="change2"
                >
                  ≤1%
                </button>
                <button
                    ref="on1"
                    style="
                      width: 55px;
                      height: 20px;
                      color: black;
                      display: inline-block;
                      border-radius: 4px;
                      line-height: 1;
                      text-align: center;
                      margin-left: 10px;
                    "
                    @click="change4"
                >
                  ≤10%
                </button>
              </li>
            <li>
              <el-button type="primary" style="margin-left: 20px" @click="reagentList(true)" size="small" class="basic-btn" >
                快速查询
              </el-button>
            </li>
            <li>
              <div style="margin-left: 8px;margin-top: 6px;font-size: 20px;">
                <i class="el-icon-question" @click="iconWarn"></i>
                <span style="font-size: 14px;font-weight: 700;">Tips</span>
              </div>
            </li>
          </ul>
          <div style="justify-self: flex-end;">
<!--              <el-tooltip class="item" effect="dark" content="列表设置" placement="top" >-->
            <el-button  type="text" @click="settingCol()" >列表设置 <i class="el-icon-s-tools"></i></el-button>
<!--              </el-tooltip>-->
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
            row-key="id"
            :expand-row-keys="expands"
            @expand-change="getReagentDetails"
        ref="multipleTable"
          :data="reagenData"
          height="600px"
          :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
          class="supTable"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无在库库存</p>
          </template>

          <el-table-column type="expand" width="50">
            <template>
<!--              <el-collapse-transition>-->
              <el-table
                  :data="reagentBorrowRecord"
                  style="width: 70%"
                  :row-style="{height: '0'}"
                  :header-cell-style="{
                  background: '#fff2cc',
                  color: '#000000',
                  border: '1px solid tan',
                }"
                  :cell-style="{
                  background: '#fff2cc',
                  border: '1px solid tan',
                }"
              >
                <el-table-column width="80px" type="index" label="序号" :index="detailsIndexMethod">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="领用时间">
                </el-table-column>
                <el-table-column  prop="createUsername" label="领用人">
                </el-table-column>
                <el-table-column width="200px" prop="borrowNum" label="领用剂量">
                  <template v-slot="scope">
                    <span>{{ scope.row.borrowNum }}{{ unit(scope.row.reagentWeightUnit) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="领用备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column type="selection" width="50">
          </el-table-column>

          <el-table-column prop="id" label="试剂编号" width="110" sortable key="code" v-if="selectColumns.indexOf('code')!=-1">
            <template slot-scope="scope" sortable>
              <span v-if="scope.row.code">{{ scope.row.code }}</span>
              <span v-else>{{ scope.row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column label="结构式" width="125" prop="structImg" key="structure" v-if="selectColumns.indexOf('structure')!=-1" >
            <template slot-scope="scope">


              <div class="demo-image__lazy1" style="overflow: auto;position: relative">
                <el-popover
                    style="position: absolute;top: 0;left: 0;z-index: 100"
                    placement="top-start"
                    width="800"
                    trigger="hover"
                    @show="reagentPropertyFn(scope.row.casNo)"
                    :content="scope.row.goodsName"
                >
                  <div v-loading="reagentPropertyLoading">
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>分子量（MW）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                        <span v-if="reagentProperty">
                          <span v-if="reagentProperty.mw">{{reagentProperty.mw}}</span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>密度（Density）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                        <span v-if="reagentProperty">
                          <span v-if="reagentProperty.density">{{reagentProperty.density}}</span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>熔点（Melting Point）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                        <span v-if="reagentProperty">
                          <span v-if="reagentProperty.meltingPoint">{{reagentProperty.meltingPoint}}</span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>沸点（Boiling Point）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                         <span v-if="reagentProperty">
                          <span v-if="reagentProperty.boilingPoint">{{reagentProperty.boilingPoint}}</span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>闪点（Flash Point）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                        <span v-if="reagentProperty">
                          <span v-if="reagentProperty.flashPoint">{{reagentProperty.flashPoint}}</span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr tableBB">
                          <span>安全性（Safety and Hazards）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableImagesBox tabelBTr tableBB">
                        <span v-if="reagentProperty">
                          <div class="">
                          <span v-if="reagentProperty.safetyAndHazards == undefined">暂无</span>
                          <div class="Safety" v-else>
                            <el-image
                                v-for="(ite, index) in reagentProperty.safetyAndHazards"
                                :src="ite"
                                :key="index"
                                alt=""
                                style="width: 32px; height: 32px"
                                :preview-src-list="reagentProperty.safetyAndHazards"
                            />
                          </div>
                      </div>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="tabelBl">
                      <el-col :span="8">
                        <div class="tableLeftTextBox tabelBTr">
                          <span>危险描述（Hazard Statements）</span>
                        </div>
                      </el-col>
                      <el-col :span="14">
                        <div class="tableRightTextBox tabelBTr">
                        <span v-if="reagentProperty">
                          <span v-if="reagentProperty.hazardStatements">
                            <el-popover
                                placement="top-start"
                                width="500"
                                trigger="hover"
                            >
                            <div style="margin-bottom: 10px" v-for="hs in reagentProperty.hazardStatements" :key="hs">{{hs}}</div>
                            <div class="reagentTextOverflow" slot="reference">
                              <div v-for="hs in reagentProperty.hazardStatements" :key="hs">{{hs}}</div>
                            </div>
                            </el-popover>
                          </span>
                          <span v-else>暂无</span>
                        </span>
                          <span v-else>暂无 -</span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <button slot="reference" class="wx_btn">物性</button>
                </el-popover>
                <el-image
                    lazy
                    style="width: 100px; height: 100px"
                    :src="scope.row.structImgUrl"
                    :preview-src-list="[`${scope.row.structImgUrl}`]">
                  <div slot="error" class="image-slot" >
                    <div style="width: 100px;height: 100px;line-height: 100px;text-align: center;background-color:#f5f7fa;color: #c0c4cc" >暂无</div>
                  </div>
                </el-image>
              </div>
            </template>
          </el-table-column >
          <el-table-column prop="reagentName" label="试剂名称" key="reagentName"  v-if="selectColumns.indexOf('reagentName')!=-1">
            <template slot-scope="scope">
              <div
                  style="color: #66b1ff; cursor: pointer"
                  @click="showDeail(scope.row)"
              >
                {{ scope.row.reagentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="enName" label="英文名称"  key="enName"  v-if="selectColumns.indexOf('enName')!=-1">
          </el-table-column>

          <el-table-column prop="casNo" label="CAS号" key="casNo" v-if="selectColumns.indexOf('casNo')!=-1">
            <template slot-scope="scope">
              <div
                  style="color: #66b1ff; cursor: pointer"
                  @click="showDeail(scope.row)"
              >  {{ scope.row.casNo }}
              </div>
              <!--              {{ scope.row.casNo }}-->
            </template>
          </el-table-column>
          <el-table-column
              key="goodsSupplierName"
              v-if="selectColumns.indexOf('goodsSupplierName')!=-1"
              prop="goodsSupplierName"
              label="品牌"
              width="100"
              sortable
          >
          </el-table-column>
          <el-table-column
              key="supplierName"
              v-if="selectColumns.indexOf('supplierName')!=-1"
              prop="supplierName"
              label="供应商"
          >
          </el-table-column>

          <el-table-column prop="cabType" label="柜机类型" width="150" sortable key="cabType" v-if="selectColumns.indexOf('cabType')!=-1">
            <template v-slot="scope">
              <span v-if="scope.row.cabType==1">智能柜</span>
              <span v-else-if="scope.row.cabType==2">门禁柜</span>
            </template>
          </el-table-column>
          <!-- 新需求无锁版：去掉位置字段 -->
          <el-table-column prop="cabName" label="试剂位置" width="150" sortable key="cabName" v-if="selectColumns.indexOf('cabName')!=-1">
          </el-table-column>

          <el-table-column
            key="reagentRemainWeight"
            v-if="selectColumns.indexOf('reagentRemainWeight')!=-1"
            prop="reagentRemainWeight"
            label="剩余剂量"
            width="110"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.reagentWeightUnit"></span>

              <span
                v-else-if="
                  (scope.row.reagentRemainWeight / scope.row.reagentWeight) *
                    100 <=
                  5
                "
                style="color: #e0001b"
                >{{ Math.floor(scope.row.reagentRemainWeight * 1000) / 1000 }}{{ unit(scope.row.reagentWeightUnit) }}
              </span>
              <span
                v-else-if="
                  (scope.row.reagentRemainWeight / scope.row.reagentWeight) *
                    100 <=
                  10
                "
                style="color: #fac563">{{ Math.floor(scope.row.reagentRemainWeight * 1000) / 1000 }}{{ unit(scope.row.reagentWeightUnit) }}
              </span>
              <span v-else>{{ Math.floor(scope.row.reagentRemainWeight * 1000) / 1000 }}{{ unit(scope.row.reagentWeightUnit) }}
              </span>

            </template>
          </el-table-column>
          <el-table-column
              key="reagentWeight"
              v-if="selectColumns.indexOf('reagentWeight')!=-1"
              prop="reagentWeight"
              label="总剂量"
              sortable
              width="90"
          >
            <template v-slot="scope">
              <span v-if="scope.row.reagentWeightUnit">
                {{scope.row.reagentWeight}}{{ unit(scope.row.reagentWeightUnit) }}
              </span>

            </template>
          </el-table-column>
          <el-table-column
              key="pure"
              v-if="selectColumns.indexOf('pure')!=-1"
              prop="pure"
              label="纯度"
              width="100"
              sortable
          >
          </el-table-column>
          <el-table-column
              key="spec"
              v-if="selectColumns.indexOf('spec')!=-1"
              prop="spec"
              label="包装规格"
          >
          </el-table-column>
          <el-table-column
              key="category"
              v-if="selectColumns.indexOf('category')!=-1"
              prop="category"
              label="分类"
          >
          </el-table-column>
          <el-table-column
              key="expires"
              v-if="selectColumns.indexOf('expires')!=-1"
              prop="expires"
              label="过期时间"
          >
          </el-table-column>
          <el-table-column
              key="stockUserName"
              v-if="selectColumns.indexOf('stockUserName')!=-1"
              prop="stockUserName"
              label="上次盘点人"
              width="100"
          >
          </el-table-column>
          <el-table-column
              key="stockTime"
              v-if="selectColumns.indexOf('stockTime')!=-1"
              prop="stockTime"
              label="上次盘点时间"
              width="110"
          >
          </el-table-column>
          <el-table-column
            key="operation"
            v-if="selectColumns.indexOf('operation')!=-1"
            prop="operation"
            label="试剂状态"
            width="130"
            sortable
          >
            <template slot-scope="scope">
              <div style="display: flex; align-items: center">
                <div
                  class="stateDot"
                  :class="[
                    scope.row.operation == '订购中' ? 'color0' : '',
                    scope.row.operation == '待入库' ? 'color1' : '',
                    scope.row.operation == '在库' ? 'color2' : '',
                    scope.row.operation == '已申领' ? 'color3' : '',
                    // scope.row.operation == '已借出' ? 'color3' : '',
                    scope.row.operation == '已取出' ? 'color4' : '',
                    scope.row.operation == '移除中' ? 'color5' : '',
                    scope.row.operation == '转用中' ? 'color6' : '',
                    scope.row.operation == '待编辑' ? 'color7' : '',
                  ]"
                ></div>
                <div>
                  <!--  -->
                  <!-- <span style="color:#4e8dfc" v-if="scope.row.operation == '订购中'" >{{ scope.row.operation }}</span> 
                  <span v-else>{{ scope.row.operation }}</span> -->

                  <span   v-if="scope.row.operation == '订购中'">
                    <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="500"
                    >
                      <span  v-if="orderInfo.expressNo">
                        <p  v-if="orderInfo.expressNo" style="font-size: 13px; font-weight: 700">物流详情</p>
                        <p>快递公司：{{ orderInfo.expressName }}</p>
                        <p>快递单号：{{ orderInfo.expressNo }}</p>
                      </span>
                      <span v-else>
                          <p>暂无物流信息~</p>
                      </span>
                      <a
                          slot="reference"
                          href="#"
                          v-if="scope.row.operation == '订购中'"
                          :style="{color:statusResult[scope.row.statusText]}"
                          @click="openDialogDetail(scope.row)"
                          @mouseenter="buyDetail(scope.row)"
                          @mouseleave="buyDetailMouseLeve()"
                      >{{ scope.row.operation }} {{ scope.row.statusText }}</a
                      >
                    </el-popover>
                  </span>

                  <a href="#" v-else>{{ scope.row.operation }}</a>
                  <el-tooltip v-if="scope.row.operation =='盘点遗失'"
                              class="item"
                              effect="light"
                              content="对于盘点遗失试剂，可进行移除；若您找到了遗失试剂可以编辑位置后重新入库"
                              placement="right-start">
                    <i class="el-icon-question" />
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              key="createUsername"
              v-if="selectColumns.indexOf('createUserName')!=-1"
              prop="createUsername"
              label="录入人"
          >
            <template v-slot="scope">
              <span v-if="!scope.row.orderId"> {{scope.row.createUsername}} </span>
            </template>
          </el-table-column>
          <el-table-column
              key="buyUsername"
              v-if="selectColumns.indexOf('buyUsername')!=-1"
              prop="createUsername"
              label="购买人"
          >
            <template v-slot="scope">
              <span v-if="scope.row.orderId"> {{scope.row.createUsername}} </span>
            </template>
          </el-table-column>
          <el-table-column
              key="gmtCreate"
              v-if="selectColumns.indexOf('gmtCreate')!=-1"
              prop="gmtCreate"
              label="创建时间"
          >
          </el-table-column>
          <el-table-column
            key="modifyUsername"
            v-if="selectColumns.indexOf('modifyUsername')!=-1"
            prop="modifyUsername"
            label="最近操作人"
            width="120"
            sortable
          ></el-table-column>
          <el-table-column
              key="gmtModified"
              v-if="selectColumns.indexOf('gmtModified')!=-1"
              prop="gmtModified"
              label="最近操作时间"
              width="110"
          >
          </el-table-column>
          <el-table-column
              key="remark"
              v-if="selectColumns.indexOf('remark')!=-1"
              prop="remark"
              label="备注"
              width="120"
          ></el-table-column>

          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.operation == '盘点中'">-</div> -->

              <div v-if="scope.row.taskId == currentTaskId">
                <img
                    @click="delReagent(scope.row)"
                    v-if="
                    scope.row.operation !== '订购中'
                  "
                    title="移除试剂"
                    src="../../assets/private/del.png"
                    style="color: #ff4d4f; height: 25px; width: 25px; float: left"
                />
                <img
                    @click="editCabinet(scope.row)"
                    v-if="scope.row.operation != '已取出'"
                    src="../../assets/private/update.png"
                    style="height: 25px; width: 25px; float: left"
                    title="编辑"
                />
                <img
                    @click="createCode(scope.row)"
                    v-if="
                    scope.row.operation !== '移除中' &&
                    scope.row.operation !== '待编辑' &&
                    scope.row.operation !== '订购中' &&
                    scope.row.operation !== '盘点遗失'
                    // && scope.row.operation !== '盘点中'
                  "
                    title="生成瓶身码"
                    src="../../assets/private/pingzi2.png"
                    style="height: 25px; width: 25px; float: left"
                />
                <img
                    @click="joinLibrary(scope.row)"
                    v-if="scope.row.operation == '在库' && scope.row.booking == false"
                    src="../../assets/private/timer-fill.png"
                    title="预约领用"
                    style="height: 25px; width: 25px; float: left"
                />
                <img
                    @click="addChoose(scope.row)"
                    v-if="(scope.row.operation == '待编辑' || scope.row.operation == '在库') && scope.row.showSelection == true"
                    src="../../assets/private/choose.png"
                    style="height: 25px; width: 25px; float: left"
                    title="加入预选"
                />
                <img
                    @click="reagentBack(scope.row)"
                    v-if="scope.row.operation == '已取出' && userId == scope.row.userId"
                    src="../../assets/private/reagentBack.png"
                    style="height: 25px; width: 25px; float: left"
                    title="试剂归还"
                />
<!--                <img-->
<!--                    @click="confirmReceived(scope.row)"-->
<!--                    v-if="scope.row.operation == '订购中' && scope.row.showConfirm == true"-->
<!--                    src="../../assets/private/确认收货.png"-->
<!--                    style="height: 25px; width: 25px; float: left"-->
<!--                    title="确认收货"-->
<!--                />-->
              </div>
              <div v-else class="">-</div>
            </template>
          </el-table-column>
        </el-table>

        <el-row :gutter="0" style="margin-top: 20px">
          <el-col :span="15">
            <span style="margin-right:10px">
              <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange"/>&nbsp;全选</span>
            <span style="margin-right:25px">已选：{{selections.length}}</span>
            <el-button
                type="primary"
                @click="handlePrint"
                size="small"
            >打印瓶身码</el-button
            >
            <el-button
                size="small"
                @click="batchSelectLocation"
            >选择位置</el-button
            >

            <el-button
                size="small"
                @click="handleDelete"
            >删除</el-button
            >

            <el-button
                size="small"
                @click="handleExport"
            >导出</el-button
            >
            <el-upload
                action=""
                style="display: inline-block; margin: 0 10px"
                :multiple="false"
                :show-file-list="false"
                :http-request="httpRequest"
                accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
            </el-upload>
          </el-col>
          <el-col :span="9">
            <el-pagination
              style="float: right"
              :pager-count="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.currentPage"
              :page-sizes="[10, 20, 30, 50, 100,500]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dataTotal"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>

      <!-- 生成瓶身码 -->
      <el-dialog
        title="瓶身码"
        :visible.sync="dialogCreate"
        class="createDia"
        width="460px"
      >
        <div>
          <div class="addressBox" id="printMe">
            <img :src="curbottleCode" alt="" />
            <div class="info">
              <!-- <div class="infoText">{{ taskName }}</div> -->
              <div class="infoText" v-if="curbottleCodeObj.code">
                {{ curbottleCodeObj.code }}
              </div>
              <div class="infoText" v-else>{{ curbottleCodeObj.id }}</div>
              <div class="infoText">{{ curbottleCodeObj.reagentName }}</div>
              <div class="infoText">{{ curbottleCodeObj.casNo }}</div>
              <!-- 新需求无锁版：去掉位置字段 -->
              <div class="infoText">
                {{
                  curbottleCodeObj.cabName +
                  "（" +
                  curbottleCodeObj.cabCoords +
                  "）"
                }}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCreate = false">取 消</el-button>
          <el-button
            type="primary"
            v-print="'#printMe'"
            @click="dialogCreate = false"
            >打 印</el-button
          >
        </div>
      </el-dialog>
      <!-- *****************************************************************************-->
      <!-- 试剂详情 -->
      <el-dialog
        title="试剂详情"
        :visible.sync="dialogCreateDiv"
        class="createDia"
        width="460px"
        v-el-drag-dialog
      >
        <el-form
          label-position="right"
          label-width="150px"
          :model="curbottleCodeObjDiv"
          size="mini"
        >
          <!--试剂编号-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">试剂编号 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">
              <span v-if="curbottleCodeObjDiv.code">{{curbottleCodeObjDiv.code}}</span>
              <span v-else>{{curbottleCodeObjDiv.id}}</span>
            </span>
          </el-form-item>
          <!--试剂名称 中文名称-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">试剂名称 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
              curbottleCodeObjDiv.reagentName
            }}</span>
          </el-form-item>
          <!--英文名称-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">英文名称 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.enName
              }}</span>
          </el-form-item>
          <!--cas号-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">CAS号 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.casNo
              }}</span>
          </el-form-item>
          <!--纯度-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">纯度 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.pure
              }}</span>
          </el-form-item>
          <!--包装规格-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">包装规格 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.spec
              }}</span>
          </el-form-item>
          <!--分类-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">分类 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.category
              }}</span>
          </el-form-item>
          <!--品牌-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">品牌 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
              curbottleCodeObjDiv.goodsSupplierName
            }}</span>
          </el-form-item>
          <!--供应商-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">供应商 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.supplierName
              }}</span>
          </el-form-item>
          <!--过期时间-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">过期时间 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.expires
              }}</span>
          </el-form-item>
          <!--结构式-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">结构式 ：</span>
            </span>
            <el-image
              v-if="curbottleCodeObjDiv.structionImg"
              :src="curbottleCodeObjDiv.structionImg"
              alt=""
              :preview-src-list="[curbottleCodeObjDiv.structionImg]"
              style="width: 50px; height: 50px"
            ></el-image>
            <el-image
              v-else
              src="https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg"
              alt=""
              style="width: 50px; height: 50px"
            ></el-image>
          </el-form-item>
          <!--实物图片-->
<!--          <el-form-item>-->
<!--            <span slot="label">-->
<!--              <span style="color: black; font-weight: bolder">实物图片 ：</span>-->
<!--            </span>-->
<!--            <el-image-->
<!--                v-if="curbottleCodeObjDiv.coverImg.length != 0"-->
<!--                :src="curbottleCodeObjDiv.coverImg"-->
<!--                alt=""-->
<!--                style="width: 50px; height: 50px"-->
<!--            ></el-image>-->
<!--            <el-image-->
<!--                v-else-->
<!--                src="https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg"-->
<!--                alt=""-->
<!--                style="width: 50px; height: 50px"-->
<!--            ></el-image>-->
<!--          </el-form-item>-->
          <!--备注-->
          <el-form-item>
            <span slot="label">
              <span style="color: black; font-weight: bolder">备注 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.remark
              }}</span>
          </el-form-item>
          <!--总剂量-->
          <el-form-item label="总剂量 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">总剂量 ：</span>
            </span>
            <span v-if="!curbottleCodeObjDiv.reagentWeightUnit">
            </span>

            <span
                v-else-if="
                (curbottleCodeObjDiv.reagentRemainWeight /
                  curbottleCodeObjDiv.reagentWeight) *
                  100 <=
                5
              "
                style="color: #e0001b; font-weight: bolder"
            >
              {{ curbottleCodeObjDiv.reagentWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
            <span
                v-else-if="
                (curbottleCodeObjDiv.reagentRemainWeight /
                  curbottleCodeObjDiv.reagentWeight) *
                  100 <=
                10
              "
                style="color: #fac563; font-weight: bolder"
            >
              {{ curbottleCodeObjDiv.reagentWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
            <span v-else style="color: black; font-weight: bolder">
              {{ curbottleCodeObjDiv.reagentWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
          </el-form-item>
          <!--剩余剂量-->
          <el-form-item label="剩余剂量 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">剩余剂量 ：</span>
            </span>
            <span v-if="!curbottleCodeObjDiv.reagentWeightUnit">
            </span>
            <span
              v-else-if="
                (curbottleCodeObjDiv.reagentRemainWeight /
                  curbottleCodeObjDiv.reagentWeight) *
                  100 <=
                5
              "
              style="color: #e0001b; font-weight: bolder"
            >
              {{ curbottleCodeObjDiv.reagentRemainWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
            <span
              v-else-if="
                (curbottleCodeObjDiv.reagentRemainWeight /
                  curbottleCodeObjDiv.reagentWeight) *
                  100 <=
                10
              "
              style="color: #fac563; font-weight: bolder"
            >
              {{ curbottleCodeObjDiv.reagentRemainWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
            <span v-else style="color: black; font-weight: bolder">
              {{ curbottleCodeObjDiv.reagentRemainWeight
              }}{{ unit(curbottleCodeObjDiv.reagentWeightUnit) }}
            </span>
          </el-form-item>
          <!--绑定柜机-->
<!--          <el-form-item label="绑定柜机 ：">-->
<!--            <span slot="label">-->
<!--              <span style="color: black; font-weight: bolder">绑定柜机 ：</span>-->
<!--            </span>-->
<!--            <span style="color: black; font-weight: bolder">-->
<!--              <span v-if="curbottleCodeObjDiv.cabName && curbottleCodeObjDiv.cabType=='待编辑'">{{curbottleCodeObjDiv.cabName}}</span>-->
<!--            </span>-->
<!--          </el-form-item>-->
          <!--存储位置-->
          <el-form-item label="试剂位置 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">试剂位置 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">
              <span>{{curbottleCodeObjDiv.cabName}}</span>
            </span>
          </el-form-item>
          <!--柜机类型-->
          <el-form-item label="柜机类型 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">柜机类型 ：</span>
            </span>
            <span
              style="color: black; font-weight: bolder"
              v-if="curbottleCodeObjDiv.cabType == 1"
              >智能柜</span
            >
            <span style="color: black; font-weight: bolder" v-else-if = "curbottleCodeObjDiv.cabType == 2">门禁柜</span>
          </el-form-item>
          <!--试剂状态-->
          <el-form-item label="试剂状态 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">试剂状态 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
              curbottleCodeObjDiv.operation
            }}</span>
          </el-form-item>
          <!--购买人-->
          <el-form-item label="购买人 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">购买人 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
                v-if="curbottleCodeObjDiv.orderId"
            >{{ curbottleCodeObjDiv.createUsername }}</span
            >
          </el-form-item>
          <!--购入价-->
          <el-form-item label="购入价 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">购入价：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
                v-if="curbottleCodeObjDiv.salesPriceTask"
            >{{ curbottleCodeObjDiv.salesPriceTask }}元</span
            >
          </el-form-item>
          <!--购买时间-->
          <el-form-item label="购买时间 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">购买时间 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
                v-if="curbottleCodeObjDiv.orderId"
            >{{ curbottleCodeObjDiv.gmtCreate }}</span
            >
          </el-form-item>
          <!--关联订单号-->
          <el-form-item label="关联订单号 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">关联订单号 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.orderNo
              }}</span>
          </el-form-item>
          <!--商品编码-->
          <el-form-item label="商品编码 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">商品编码 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
                curbottleCodeObjDiv.goodsNo
              }}</span>
          </el-form-item>
          <!--录入人-->
          <el-form-item label="录入人 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">录入人 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
                v-if="!curbottleCodeObjDiv.orderId"
            >{{ curbottleCodeObjDiv.createUsername }}</span
            >
          </el-form-item>
          <!--录入时间-->
          <el-form-item label="录入时间 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">录入时间 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
                v-if="!curbottleCodeObjDiv.orderId"
            >{{ curbottleCodeObjDiv.gmtCreate }}</span
            >
          </el-form-item>
          <!--上次盘点人-->
          <el-form-item label="上次盘点人 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">上次盘点人 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
            >{{ curbottleCodeObjDiv.stockUserName }}</span
            >
          </el-form-item>
          <!--上次盘点时间-->
          <el-form-item label="上次盘点时间 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">上次盘点时间 ：</span>
            </span>
            <span
                style="color: black; font-weight: bolder"
            >{{ curbottleCodeObjDiv.stockTime }}</span
            >
          </el-form-item>
          <!--最近操作人-->
          <el-form-item label="最近操作人 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder"
                >最近操作人 ：</span
              >
            </span>
            <span style="color: black; font-weight: bolder">{{
              curbottleCodeObjDiv.modifyUsername
            }}</span>
          </el-form-item>
          <!--最近操作时间-->
          <el-form-item label="最近操作时间 ：">
            <span slot="label">
              <span style="color: black; font-weight: bolder">最近操作时间 ：</span>
            </span>
            <span style="color: black; font-weight: bolder">{{
              curbottleCodeObjDiv.gmtModified
            }}</span>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCreateDiv = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- *****************************************************************************-->

      <!-- 绑定柜机弹框(修改) -->
      <el-dialog
        title="绑定柜机"
        :visible.sync="dialogBind"
        class="bindDia"
        width="800px"
      >
        <div class="searchName">
          <input
            type="text"
            v-model="cabName"
            placeholder="查询柜子名称"
            @keyup.enter="searchCabs"
          />
          <el-button type="primary" @click="searchCabs">查询</el-button>
        </div>
        <div class="all-cabinet" v-if="canBindCab.length>0">
          <!-- <p>存储柜子</p> -->
          <ul>
            <li
              @click="onRadioChange(item)"
              v-for="(item, index) in canBindCab"
              :key="index"
            >
              <el-radio
                v-model="cabId"
                :label="item.id"
                :disabled="item.sum == 0"
              >
                <div
                  class="text-overflow"
                  style="width: 360px; margin-right: 10px"
                >
                  {{ item.cabName }}
                </div>
                <div class="centerbox">
                  <span class="cabinet-type" v-if="item.cabType == 1"
                    >智能柜</span
                  >
                  <span class="cabinet-type2" v-else>门禁柜</span>
                  <span v-if="item.cabType == 1" class="remnant">
                    剩余可存量：<i>{{ item.sumGrid }}</i>
                  </span>
                  <span v-else class="remnant"
                    >已用托盘/总托盘：<i>{{
                      (item.sumGrid ? item.sumGrid : 0) + "/" + item.cabCount
                    }}</i></span
                  >
                </div>
              </el-radio>
            </li>
          </ul>
        </div>
        <div v-else style="margin-top: 30px">
          <span style="font-family: 'SimSun', '宋体';color: #cccccc">您还没有柜机哦，现在去新建一个吧 </span>
          <el-link :underline="false" type="primary" @click="newCabinet">去新建 >></el-link>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBind = false">取 消</el-button>
          <!-- <el-button type="primary" @click="bindCabinet">确 定</el-button> -->
        </div>
      </el-dialog>
      <!-- 生成位置码 -->
      <el-dialog
        title="生成托盘码"
        :visible.sync="dialogPlace"
        class="placeDia"
        width="460px"
      >
        <ul>
          <li>
            <label>所在行</label>
            <input
              type="text"
              placeholder="请输入所在行"
              v-model="curLocationCodeObj.cabGridx"
              disabled
            />
          </li>
          <li>
            <label>所在列</label>
            <input
              type="text"
              placeholder="请输入所在列"
              v-model="curLocationCodeObj.cabGridy"
              disabled
            />
          </li>
        </ul>
        <!-- <button class="locking">校验并锁定位置</button>
        <span class="tips">当前位置已被占用，请选择其他位置</span> -->
        <div class="addressBox" id="print2">
          <img :src="curLocationCode" alt="" />
          <div class="info">
            <div class="infoText">
              柜机位置：{{ curLocationCodeObj.cabAddress }}
            </div>
            <div class="infoText">
              柜机名称：{{ curLocationCodeObj.cabName }}
            </div>
            <div class="infoText">
              试剂位置：{{
                curLocationCodeObj.cabGridx + "," + curLocationCodeObj.cabGridy
              }}
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogPlace = false">取 消</el-button>
          <el-button
            type="primary"
            v-print="'#print2'"
            @click="dialogPlace = false"
            >确认生成并打印</el-button
          >
        </div>
      </el-dialog>
      <!-- 选择门禁柜位置 -->
      <el-dialog
        title="选择托盘/查看已存试剂"
        :visible.sync="dialogSelect"
        width="900px"
        class="selectLocationBox"
      >
        <div class="btnWrapper" style="margin-bottom: 15px">
          <el-button type="primary" size="small" @click="selectPlace"
            >确定选择托盘</el-button
          >
          <el-button size="small" @click="getCabinetDetail"
            >查看已存试剂</el-button
          >
<!--          <el-button size="small" @click="openEditNum">修改存储数量</el-button>-->
        </div>
        
          <!-- @cell-click="handleCellClick" 
             :cell-style="handleCellStyle" -->
        <el-table
          :data="selectLocationList2"
          @cell-click="handleCellClick" 
          :cell-style="handleCellStyle"
          border
          style="width: 100%; height: 100%"
          max-height="500"
        >
          <el-table-column type="index" width="70px" :index="indexMethod">
          </el-table-column>

          <el-table-column
            v-for="(item, index) in dataColumn"
            :key="index"
            :label="colIndexArr[index] + '列'"
            min-width="120px"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row[index].isDel"
                style="text-decoration: line-through; background-color: #d9d9d9"
              >
                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}（余-->
<!--                <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                  scope.row[index].reagentTotalNum - scope.row[index].reagentNum-->
<!--                }}</span>-->
<!--                <span v-else>0</span>-->
<!--                ）-->
              </div>
              <span v-else>
                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}
                <span>（已存 {{scope.row[index].reagentNum}}）</span>
<!--                {{ scope.row[index].numX }}, {{ scope.row[index].numY }}（余-->
<!--                <span v-if="scope.row[index].reagentTotalNum != null">{{-->
<!--                  scope.row[index].reagentTotalNum - scope.row[index].reagentNum-->
<!--                }}</span>-->
<!--                <span v-else>0</span>-->
<!--                ）-->
              </span>
            </template>
          </el-table-column>
        </el-table>

        <!-- <div style="margin-top: 10px">
          共计{{ lockerCabinet.numX }} 行{{ lockerCabinet.numY }} 列<span
            style="margin-left: 10px"
            >{{ lockerCabinet.numX * lockerCabinet.numY }}个位置</span
          >
        </div> -->
      </el-dialog>

      <!-- 选择门禁柜位置 1.0 废弃-->
      <el-dialog
        title="选择位置/已存数量"
        width="900px"
        class="selectLocationBox"
      >
        <el-table
          :data="selectLocationList"
          style="width: 100%"
          max-height="600px"
        >
          <el-table-column label="位置" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.numX + "," + scope.row.numY }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reagentNum" label="已存数量" width="180">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="selectText" @click="onSelectLocation(scope.row)"
                >选择</span
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :dataTotal="locationDataTotal"
          :totalpage="locationTotalpage"
          :pagesize="locationSearchData.pageSize"
          @changePage="locationChangePage"
        ></Pagination>
        <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="dialogSelect = false">取 消</el-button>
              <el-button type="primary" @click="dialogSelect = false">确 定</el-button>
            </span> -->
      </el-dialog>

      <!--    导出弹框-->
      <el-dialog title="请选择" :visible.sync="exportToastVisible" width="30%">
        <el-form :model="downloadform">
          <el-form-item label="">
            <el-radio v-model="downloadform.radio" label="1">仅导出选中的数据</el-radio>
          </el-form-item>
          <el-form-item label="">
            <el-radio v-model="downloadform.radio" label="2">导出试剂全表</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exportToastVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleExportLockerReagent">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 批量打印瓶身码 -->
      <el-dialog title="瓶身码" :visible.sync="printListDiag" width="460px">
        <div id="printList">
          <div
            class="addressBox1"
            v-for="(item, index) in printData"
            :key="index"
            style="page-break-after:always"
          >
            <img :src="'data:image/png;base64,' + item.codeImg" alt="" />
            <div class="info">
              <!-- <div class="infoText">{{ taskName }}</div> -->
              <div class="infoText" v-if="item.code">{{ item.code }}</div>
              <div class="infoText" v-else>{{ item.id }}</div>
              <div class="infoText">{{ item.reagentName }}</div>
              <div class="infoText-bottom">{{ item.casNo }}</div>
              <!-- 新需求无锁版：去掉位置字段 -->
              <div class="infoText">
                {{ item.cabName + "（" + item.cabCoords + "）" }}
              </div>
           </div>
            <!-- <span style="position:absolute;padding-top: 90px;padding-left: 35px; color: #000;font-weight: 600;">{{item.id}}</span> -->
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="printListDiag = false">取 消</el-button>
          <el-button
            type="primary"
            v-print="'#printList'"
            @click="printListDiag = false"
            >确认打印</el-button
          >
        </div>
      </el-dialog>

      <!-- 查看物流进度的对话框-->
      <el-dialog title="物流详情" :visible.sync="progessVisible" width="400px">
        <div>
          <div class="track-rcol">
            <div class="track-list">
              <ul>
                <div style="font-weight: 700;font-size: 14px;">
                  <p >物流公司：{{ orderInfo.expressName }}</p>
                  <p >快递单号：{{ orderInfo.expressNo }}</p>
                </div>

              </ul>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 转借弹窗 -->
      <el-dialog
          title="组内转用申请"
          :visible.sync="transDialog"
          class="borrowDia"
          width="460px"
      >
        <ul>
          <li>
            <label>申请剂量</label>
            <input
                type="number"
                placeholder="请输入剂量"
                v-model="borrowGoodsdata.borrowNum"
            />
            <span class="tips">*不可大于当前已剩余剂量</span>
          </li>
<!--          <li>-->
<!--            <label>开门方式</label>-->
<!--            <input type="text" disabled value="身份码开门" />-->
<!--          </li>-->
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button @click="transDialog = false">取 消</el-button>
          <el-button type="primary" @click="confirmBorrows()">确 定</el-button>
        </div>
      </el-dialog>

      <!--自定义列表设置弹窗-->
      <el-dialog
          title="选择需要显示的列"
          :visible.sync="showColDialog"
          width="500px"
      >
        <el-divider></el-divider>
       <div>
         <el-checkbox-group v-model="selectColumnsParams" >
             <div class="check-box-list" v-for="item in columns" :key="item.id">
               <el-checkbox :label="item.columnName" :disabled="item.columnName=='casNo'" @change="handleCheckChange(item)" >{{item.label}}</el-checkbox>
             </div>
         </el-checkbox-group>
       </div>
        <el-divider></el-divider>
        <div slot="footer" class="dialog-footer">
          <el-button @click="columnReset()" style="float:left">重置</el-button>
          <el-button @click="showColDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitSelectRow()">确 定</el-button>
        </div>
      </el-dialog>

    </div>
    
    <!--    查看试剂弹出框-->
    <el-dialog
      title="查看已存试剂"
      :visible.sync="cabinetDetailVisible"
      width="600px"
    >
      <span style="color: black; font-weight: bold"
        >托盘码：{{ placeCode }}</span
      >
      <span style="margin-left: 100px; color: black; font-weight: bold"
        >已存数量：{{ lockerCabinetGrid.reagentNum }}</span
      >
      <!--            <div style="margin-top: 10px;color: black;font-weight: bold">已存试剂列表</div>-->
      <el-table :data="newReagentList" border style="margin-top: 10px">
        <el-table-column label="试剂编号" prop="id">
          <template slot-scope="scope">
            <span v-if="scope.row.code">{{scope.row.code}}</span>
            <span v-else>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="试剂名称" prop="reagentName">
        </el-table-column>
        <el-table-column label="试剂状态" prop="">
          <template slot-scope="scope">
            {{ handleStatusConvert(scope.row.operation) }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cabinetDetailVisible = false">取 消</el-button>
        <el-button type="primary" @click="cabinetDetailVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改存储数量 dialog-->
    <el-dialog
        title="修改存储数量"
        :visible.sync="editNumDialog"
        class="placeDia"
        width="600px"
      >
        <el-row style="text-align: center; line-height: 40px">
          <el-col :span="4">
            <span>存储数量</span>
          </el-col>
          <el-col :span="8">
            <el-input
              v-model="editNum"
              type="number"
              :disabled="editInputDisable"
            />
          </el-col>
          <el-col :span="8">
            <el-button
              type="primary"
              style="padding: 7px 14px"
              @click="editInputDisable = false"
              >修改</el-button
            >
            <el-button
              type="primary"
              style="padding: 7px 14px"
              @click="saveEditNum"
              >保存</el-button
            >
          </el-col>
        </el-row>
    </el-dialog>

    <el-drawer title="我的预选" :visible.sync="chooseTable" direction="rtl" :show-close="false"
               :before-close="cancelChooseTable" size="50%" >
      <el-table :data="chooseGridData" @selection-change="chooseSelectHandler">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column property="reagentCode" label="试剂编号" ></el-table-column>
        <el-table-column property="reagentName" label="试剂名称"></el-table-column>
        <el-table-column property="casNo" label="CAS号"></el-table-column>
        <el-table-column property="brand" label="品牌"></el-table-column>
        <el-table-column property="reagentPosition" label="试剂位置"></el-table-column>
        <el-table-column property="reagentSurplusStr" label="剩余剂量"></el-table-column>
        <el-table-column property="reagentTotalStr" label="总剂量"></el-table-column>
        <el-table-column property="createTime" label="加入时间"></el-table-column>
      </el-table>
      <div class="demo-drawer_footer" style="margin-top: 20px;">
<!--      <div class="demo-drawer_footer" style="margin-top: 20px;" v-show="showChoose">-->
        <el-button @click="cancelChooseTable">取 消</el-button>
        <el-button @click="delChoose()">移除</el-button>
        <el-button type="primary" @click="choosePosition">选择位置</el-button>

      </div>
    </el-drawer>

    <div>
      <transition name="fade">
        <!-- <loading v-if="isLoading"></loading> -->
      </transition>
    </div>

    <el-dialog title="添加试剂" :visible.sync="addReagentVisible" width="30%" :show-close="false">
      <div>
        <el-row>
          <el-col><span><el-radio v-model="reagentRadio" label="1">单个添加 (在线逐一编辑试剂信息并添加)</el-radio></span></el-col>
        </el-row>
        <el-row style="padding-top: 25px;">
          <el-col>
            <span><el-radio v-model="reagentRadio" label="2">批量添加 (编辑Excel文件,一键导入添加)</el-radio></span>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="addReagentVisible = false,reagentRadio='1'">取 消</el-button>
          <el-button type="primary" @click="reagentVisibleSubmit">确 定</el-button>
        </span>
    </el-dialog>

    <div>
      <el-dialog title="批量新增试剂" :visible.sync="addBatchReagentVisible" width="40%" class="batchReagentClass">
        <div>
          <div>
            <span><i class="el-icon-warning" /> 请先下载 <el-link type="primary" :ununderline="false" @click="handleDownloadTemplate">试剂模板Excel</el-link></span>
            <span>  按要求编辑完成后在上传，一键完成！</span>
          </div>
          <div>
            <span>
                          <el-upload
                              class="upload-demo"
                              ref="upload"
                              action=""
                              :multiple="true"
                              :file-list="fileList" accept=".xlsx,.xls"
                              :on-change="handleFileChange1" :on-remove="handleFileRemove1"
                              :auto-upload="false" style="padding-top: 20px">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
              <el-progress v-show="progress" :percentage="progressLen"/>
          </span>
          </div>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addBatchReagentVisible = false,fileList=[],progress = false,realFileList=[]">取 消</el-button>
          <el-button type="primary" @click="submitUpload1">确认上传</el-button>
        </span>
      </el-dialog>
    </div>

    <div>
      <el-dialog title="Tips" :visible.sync="iconWarnDialog" width="40%" :before-close="iconWarnDialogClose" v-el-drag-dialog>
        <div style="font-size: 16px;font-weight: 500;line-height: 30px">
          <div>1、搜索操作人加订购中，可用于该用户集中确认收货；</div>
          <div>2、关键字搜索框如输入“铜”，只要是含“铜”字的试剂全部展示；</div>
          <div>3、新老交替：原始位置为导入位置；</div>
          <div>4、“物性”鼠标悬浮显示，“结构式”鼠标点击放大；</div>
          <div>5、操作栏点击“预选”，右上角出现预选池，用于将原始位置变更为系统位置；</div>
          <div>6、加入预选池的先后顺序即为选择系统位置后打印瓶身码的出纸顺序，一 一对应；</div>
          <div>7、操作栏点击“领用”，右上角出现领用筐，用于一次领用多个试剂；</div>
          <div>8、精细版“快消品”可一直停留在“待入库”状态至直接删除，可不入库不扫码不领用</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import elDragDialog from "../../directive/el-dragDialog";
import Loading from "@/components/loading";
import {downloadFile, downloadFileTemplate} from "@/util/common";
import {EventBus} from "@/config/event-bus";
export default {
  // components:{ Loading  },
  directives: {
    elDragDialog,
  },
  data() {
    return {
      showColDialog:false,
      selectColumns:['code','structure','reagentName','casNo','goodsSupplierName','cabName','reagentRemainWeight','pure','operation','modifyUsername','remark'],
      selectColumnsParams:['code','structure','reagentName','casNo','goodsSupplierName','cabName','reagentRemainWeight','pure','operation','modifyUsername','remark'],
      columns:[],// 所有列表
      statusResult: {"(待收货)":"#da0707","(待发货)":"blue","(待确认)":"blue","(待审核)":"blue"},
      iconWarnDialog: false,
      reagentPropertyLoading:false,
      reagentProperty: null,
      realFileList: [],
      fileName: [],
      reagentRadio: '1',
      addReagentVisible: false,
      progress : false,
      progressLen: 0,
      addBatchReagentVisible: false,
      fileList: [],
      orderInfo:{
        expressName:"",
        expressNo:"",
        statusText:"",
      },
      flag:false,
      expands: [],
      reagentBorrowRecord: [],
      showChooseNum: '',
      showChooseBtn: false,
      showBookingNum: '',
      showBookingBtn: false,
      showChoose: false,
      chooseGridData: null,
      chooseTable: false,
      borrowGoodsdata: {
        borrowNum: null,
        id: null,
        reagentRemainWeight: null,
      },
      transDialog: false,
      multiSelect: [], // 复选框
      isIndeterminate: false,
      checkAll: false,
      downloadform: {
        radio: '1',
      },
      editNumDialog:false,
      editInputDisable: true,
      editNum: null,
      newReagentList: [],
      lockerCabinetGrid: {},
      cabinetDetailVisible:false,
      row:null,
      column:null,
      lockerCabinet: {
        columnList: [],
        rowList: [],
        numX: "",
        numY: "",
      },
      colIndexArr: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "U",
        "V",
        "W",
        "x",
        "Y",
        "Z",
      ],
      selectLocationList2: [],
      dataColumn: null,
      //end
      isLoading: false,
      // 物流进度对话框
      progessVisible: false,
      progressInfo: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      cabGridx: "",
      cabGridy: "",
      dialogPlace: false,
      cabId: "",
      cabName: "",
      bindCartNum: "",
      dialogBind: false,
      dialogCreate: false,
      dialogCreateDiv: false,
      show: false,

      searchData: {
        reagentName:"",
        casNo: "",
        originalLocation: "",
        locationType: "1",
        reagentRemainWeight: null,
        pageNum: 1,
        pageSize: 10,
      },
      reagenData: [],
      canBindCab: [],
      myCartNum: "",
      num: 1,
      dialogAddCart: false,
      dialogBorrow: false,
      content: "",
      tableArr: [],
      reagentId: "",
      codeData: "",
      totalpage: 0,
      dataTotal: 0,
      reagentRemainWeight_1: 0,
      reagentRemainWeight_10: 0,

      //当前展示位置码信息
      curLocationCode: "",
      curLocationCodeObj: "",

      //当前展示瓶身码信息
      curbottleCode: "",
      curbottleCodeObj: {
        cabAddress: "",
      },

      //详情
      curbottleCodeObjDiv: {
        goodsNo: "",
        orderNo: "",
        reagentName: "",
        casNo: "",
        scope: "",
        goodsSupplierName: "",
        coverImg: "",
        structionImg: "",
        specNames: "",
        reagentRemainWeight: "",
        reagentWeightUnit: "",
        reagentWeight: "",
        cabName: "",
        cabCoords: "",
        cabType: "",

        operation: "",
        modifyUsername: "",
        gmtModified: "",
      },
      selectValue: null,
      //公开设置
      openSetting: true,
      openBtnsFlag: true,
      //管理员查看未归还试剂
      visitType: null,
      //当前账户课题组id
      currentTaskId: null,
      currentLocationId: "",
      dialogSelect: false,
      locationDataTotal: 0,
      locationTotalpage: 0,
      locationSearchData: {
        pageSize: 10,
        pageNum: 1,
      },
      //选择位置
      selectLocationId: "",
      selectLocationList: [],
      //改 门禁柜相关
      gridId: "",
      numX: "",
      numY: "",
      cabType: 1,

      //用户类型 1管理员 2普通用户
      queryType: null,
      exportToastVisible: false,
      //勾选项
      selections: [],
      printListDiag: false,
      printData: [],
      itemLoding:"",
      taskName:null,
      chooseIds: [],
      chooseSelections: [],
      chooseFlag: 1,
      timeFlag : null,
      userId: null,
      confirmData: null,
    };
  },
  created() {
    
    //获取课题组id
    const userInfo = localStorage.getItem("userInfo");
    const { taskId, userRole,taskName,id } = JSON.parse(userInfo);
    this.queryType = userRole == 1 ? 1 : 2;
    this.currentTaskId = taskId;
    this.taskName = taskName;
    this.userId = id;
    this.visitType = this.$route.query.visitType;
    if (this.visitType) {
      this.selectValue = 3;
    }
    this.reagentList();
    this.$forceUpdate();
    this.getAllColumu();
  },

  activated(){
    this.getCabinetList();
  },
  updated: function () {
    this.$nextTick(() => {
      this.$refs.multipleTable.doLayout();
    });
  },

  methods: {
    // 列重置
    columnReset(){
      this.selectColumnsParams = ['code','structure','reagentName','casNo','goodsSupplierName','cabName','reagentRemainWeight','pure','operation','modifyUsername','remark']
      this.columns.forEach(item=>{
        item.visible = false;
      })

      this.selectColumnsParams.forEach(columnName  =>{
        let column = this.columns.find(item => item.columnName === columnName);
        if (column) {
          column.visible = true;
        }
      })
    },
    handleCheckChange(item){
      item.visible = !item.visible;
    },
     settingCol(){
      this.showColDialog = true;
      // this.getAllColumu();
    },

    async getAllColumu(){
      let map = await this.$apiFetch.get(`/customColumn/getAllColumn`)
      let allColumns = map.data.allColumns;

      this.columns = allColumns;
      let tempSelectColumns = allColumns.filter(column => column.visible == true).map(column => column.columnName);
      if(tempSelectColumns && tempSelectColumns.length>0){
        this.selectColumns = tempSelectColumns;
        this.selectColumnsParams = tempSelectColumns;
      }else {
        this.selectColumnsParams = this.selectColumnsParams;
        this.selectColumnsParams.forEach(columnName  =>{
          let column = this.columns.find(item => item.columnName === columnName);
          if (column) {
            column.visible = true;
          }
        })
      }
    },
    submitSelectRow(){
      let params = this.columns;
      console.log("传递的参数：",params)
      this.$apiFetch.post(`/customColumn`,params)
          .then(res=>{
            this.showColDialog = false;
            this.$message.success("设置成功")
            window.location.reload();
          })
          .catch(err=>{
            this.$message.error("请求失败")
          })
    },

    newCabinet(){
      this.$router.push({path:'cabinetRun10',query:{'type':'addC'}});
    },
    reagentPropertyFn(casNo){
      this.reagentPropertyLoading = true
      this.reagentProperty = null
      this.$apiFetch
          .get(`/lockerCas/searchCas`, {
            content:casNo
          })
          .then((res) => {
            this.reagentProperty = res.data
            if(res.data){
              if(res.data.hazardStatements){
                let HazardStatementsParseValue = res.data.hazardStatements?JSON.parse(res.data.hazardStatements):["-"]
                this.reagentProperty.hazardStatements = HazardStatementsParseValue;
              }
            }
            this.reagentPropertyLoading = false
          })
          .catch(err=>{
            this.reagentPropertyLoading = false
          })
    },
    reagentBack(row){
      const params = {};
      params.reagentId = row.id;
      this.$confirm(
          "确认归还试剂吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$apiFetch.post('/lockerReagentFree/reagentGetAndBack',params)
            .then((res) => {
              if(!res.data.code){
                this.reagentList();
              }else{
                this.$message.error(res.data.description)
              }
            })
            .catch((error) => {
              console.log(error)
            })
        });
    },
    detailsIndexMethod(index){
      return this.reagentBorrowRecord.length - index
    },
    handleFileChange1(file, fileList){
      this.realFileList = fileList;
    },
    handleFileRemove1(file, fileList){
      this.realFileList = fileList;
    },
    reagentVisibleSubmit(){
      const radio = this.reagentRadio;
      if('1' == radio){
        this.$router.push({ path: "addReagentFree", query: { name: "新增试剂" } });
      }else{
        this.addBatchReagentVisible = true;
      }
    },
    async submitUpload1() {
      var param = new FormData();
      const files = this.realFileList;
      if(files.length <1){
        return
      }
      files.forEach(file => {
        param.append('file', file.raw);
        this.fileName.push(file.name);
      });
      this.progress = true;
      //this.progressLen = Math.ceil(Math.random()*50);
      this.progressLen = 1;
      var num = this.progressLen;
      var timer = setInterval(() => {
        num = num+1;
        if(num >= 99){
          this.progressLen = 99;
        }else {
          this.progressLen = num;
        }
      },600);
      const res =  await this.$apiFetch.postUpload('/lockerReagentFree/importDataMultipart', param)
      clearInterval(timer);
      var resultCode = res.data.errorCode;
      if('200' == resultCode){
        this.successResult();
      }else{
        this.errorResult(res.data);
      }
    },
    successResult(response, file, fileList){
      this.progressLen = 100;
      this.$alert('文件上传成功', '', {
        confirmButtonText: '确定',
        iconClass: 'el-icon-warning',
        callback: action => {
          this.addBatchReagentVisible = false;
          this.addReagentVisible = false;
          this.reagentList();
          this.reagentRadio = '1';
          this.progress = false;
          this.progressLen = 0;
          this.$refs.upload.clearFiles();
          this.realFileList = [];
        }
      });
    },
    errorResult(err, file, fileList){
      var msg = ''
      if(null != err.errorMsg){
        msg = err.errorMsg;
      }
      this.$alert('文件上传失败，'+msg, '请重新选择', {
        confirmButtonText: '确定',
        iconClass: 'el-icon-warning',
        callback: action => {
          this.progress = false;
          this.progressLen = 0;
        }
      });
    },
    // expands 只展开一行
    expandsOneRow(row, expandedRows) {
      if (expandedRows.length) {
        //说明展开了
        this.expands = [];
        if (row) {
          this.expands.push(row.id); //只展开当前行id
        }
      } else {
        //说明收起了
        this.expands = [];
      }
    },
    // 获取试剂详情展开按钮
    getReagentDetails(row, expandedRows) {

      this.expands = []
      if (this.expands.includes(row.id)) {
        //已经展开的话，就关闭，移除在expands中的key
        this.expands = this.expands.filter((val) => val !== row.id);
      } else {
        this.getDetailFn(row.id).then(() => {
          this.expands.push(row.id);
          this.expandsOneRow(row, expandedRows); // 收起
        });
      }
    },

    // 获取试剂详情异步请求
    //异步请求接口
    async getDetailFn(reagentId) {
      let res = await this.$apiFetch.get(
          `/lockerBorrowRecord/reagentDetailsBorrowRecord/${reagentId}`
      );
      this.reagentBorrowRecord = res.data;
    },

    getChooseData(){
      this.$apiFetch
          .get("/reagentPreselection/getChooseData", null)
          .then((res) => {
            const count = res.data;
            if(count > 0){
              this.showChooseBtn = true;
              this.showChooseNum = count;
            }else {
              this.showChooseBtn = false;
            }

          }).catch((res)=>{
      })
    },
    getBookingData(){
      this.$apiFetch
          .get("/lockerBorrowRecordFree/selectMarkRecordCount", null)
          .then((res) => {
            const count = res.data;
            if(count > 0){
              this.showBookingBtn = true;
              this.showBookingNum = count;

              localStorage.setItem("yuYueNum",count);
              EventBus.$emit('yuYueNum',count);
            }else {
              this.showBookingBtn = false;
            }

          }).catch((res)=>{
      })
    },
    reagentBorrow(row){
      if (row.operation != "已取出") {
        this.$message.error("只有已取出试剂才可转用");
        return;
      }
      if (row.reagentRemainWeight === 0) {
        this.$message.error("剩余剂量不足");
        return;
      }
      if(row.userId == this.userId){
        this.$message.error("您已转用，不能重复申请");
        return;
      }
      this.borrowGoodsdata.id = row.id;
      this.borrowGoodsdata.reagentRemainWeight = row.reagentRemainWeight;
      this.transDialog = true;

    },
    async confirmBorrows(){
      if(!this.borrowGoodsdata.borrowNum){
        this.$message.error('请输入借用剂量')
        return;
      }
      let num = this.borrowGoodsdata.borrowNum*1;
      let reagentRemainWeight = this.borrowGoodsdata.reagentRemainWeight *1;
      console.log(num);
      console.log(reagentRemainWeight);
      if(num > reagentRemainWeight){
        this.$message.error('剩余剂量不足')
        return;
      }
      this.$apiFetch
          .post("/lockerBorrowRecord/lendReagent", {
            borrowNum: this.borrowGoodsdata.borrowNum,
            id: this.borrowGoodsdata.id,
          })
          .then((res) => {
            console.log(res.data);
            if (!res.data.code) {
              this.transDialog = false;
              this.$notify({
                title: "组内转用申请已发送",
                message: "请在我的操作-组内转用中查看进度",
                position: "bottom-right",
              });
              this.$apiFetch
                  .get("/lockerBorrowRecord/getBorrowNoticeNum")
                  .then((res) => {
                    localStorage.setItem("lendNum",res.data);
                    EventBus.$emit('lendNum',res.data);
                  });
            } else {
              this.$message.error(res.data.description);
            }
          });
    },
    // 全选
    handleCheckAllChange(val) {
      this.checkAll = val;
      var rows = this.reagenData;
      var value = val ? rows : [];
      if (val) {
        rows.forEach((row) => {
          console.log(row);
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      console.log(this.multipleSelection);
    },
      joinLibrary(row) {
      if (row.operation != "在库") {
        this.$message.error("只有在库试剂才可预约");
        return;
      }
      let params = {
        id: row.id,
      };
      this.$apiFetch
        .post("/lockerBorrowRecord/addMarkReagent", params)
        .then((res) => {
          console.log(res);
          if (!res.data.code) {
            this.$message({
              showClose: true,
              message: "已加入领用",
              type: "success",
            });
            //this.$router.push({ path: "borrowInfoFree",query:{type:"reagentRun"} });
            this.reagentList();
          } else {
            this.$message.error(res.data.description);
          }
        });
    },

    // 确定选择位置
    selectPlace() {
      if (
        !(
          this.row != undefined &&
          this.column != undefined &&
          this.row != "" &&
          this.column != ""
        )
      ) {
        this.$message.error("请先选择位置");
        return;
      }
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          if (res.data.del) {
            this.$message.error("该位置已被禁用，请重新选择");
            return;
          } else {

            //通过这个标识，判断预选功能选择位置，还是说通过试剂管理页面选择位置，
            //为1时，通过试剂管理页面选择位置
            //为2时，通过确认收货按钮选择位置
            //为3时，通过预选池选择位置
            let tempReagentIdArr;
            if(1 == this.chooseFlag){
                tempReagentIdArr = this.selections.map((item, index) => {
                return item.id;
              });
            }else if(2 == this.chooseFlag){
              console.log(this.confirmData);
              tempReagentIdArr = [this.confirmData.id];
            }else {
              tempReagentIdArr = this.chooseSelections.map((i) => i.reagentId);
            }
            console.log("chooseFlag:"+this.chooseFlag);
            console.log("tempReagentIdArr:"+tempReagentIdArr);
            //为2时，这边处理选择位置+确认收货
            if(2 == this.chooseFlag){
              this.updateReagentCabinetAndConfirm(tempReagentIdArr,2,this.currentLocationId,res.data.id);
            }else {
              this.updateReagentCabinet(tempReagentIdArr,2,this.currentLocationId,res.data.id);
            }
          }
        });
    },

    updateReagentCabinet(ids,cabType,cabId,gridId){
      console.log("试剂id：",ids)
      console.log("柜机类型",cabType)
      console.log("柜机id",cabId)
      console.log("柜子id：",gridId)
      this.$apiFetch
        .post(`/lockerReagentFree/selectLocation`, {
          ids,
          cabType,
          cabId,
          gridId
        })
        .then((res) => {
          if(res.data.code == 418){
            // this.$Message.error(res.description)
            this.$message({message:res.data.description,type:'error',customClass:'zZindex'});
            return;
          }else{
            this.$message.success("修改成功");
            this.reagentList();
            this.dialogSelect = false;
            this.dialogBind =false;
            if(3 == this.chooseFlag){
              this.chooseDataList();
            }

            //恢复默认值
            this.chooseFlag = 1;
            this.confirmData = null;
          }
          
        });
    },

    //选择位置+确认收货
    updateReagentCabinetAndConfirm(ids,cabType,cabId,gridId){
      console.log("试剂id：",ids)
      console.log("柜机类型",cabType)
      console.log("柜机id",cabId)
      console.log("柜子id：",gridId)
      this.$apiFetch
          .post(`/lockerReagent/selectLocation`, {
            ids,
            cabType,
            cabId,
            gridId
          })
          .then((res) => {
            if(res.data.code == 418){
              // this.$Message.error(res.description)
              this.$message({message:res.data.description,type:'error',customClass:'zZindex'});
              return;
            }else{
              this.$message.success("修改成功");
              this.reagentList();
              this.dialogSelect = false;
              this.dialogBind =false;
              if(3 == this.chooseFlag){
                this.chooseDataList();
              }

              //恢复默认值
              this.chooseFlag = 1;
              //调用确认收货
              this.confirmReceivedById(this.confirmData.id)
              this.confirmData = null;
            }
          });
    },

    handleStatusConvert(status) {
      if (status == 8) {
        return (status = "订购中");
      } else if (status == 1) {
        return (status = "待入库");
      } else if (status == 2) {
        return (status = "在库");
      } else if (status == 3) {
        return (status = "已借出");
      } else if (status == 4) {
        return (status = "已取出");
      } else if (status == 5) {
        return (status = "移除中");
      } else if (status == 6) {
        return (status = "移除成功");
      } else if (status == 7) {
        return (status = "转借申请中");
      } else if (status == 88) {
        return (status = "购物车中");
      } else if (status == 9) {
        return (status = "盘点中");
      } else if (status == 10) {
        return (status = "盘点遗失");
      }
       else {
        return (status = "-");
      }
    },

    // 查看已存试剂
    getCabinetDetail() {
      if (
        !(
          this.row != undefined &&
          this.column != undefined &&
          this.row != "" &&
          this.column != ""
        )
      ) {
        this.$message.error("请先选择位置");
        return;
      }
      this.placeCode =
        this.lockerCabinet.cabName +
        "（" +
        this.rowIndex +
        "," +
        this.columnIndex +
        "）";
      
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          this.lockerCabinetGrid = res.data;
          this.$apiFetch
            .get(`/cabinetGrid/queryReagentByGrid/${res.data.id}`)
            .then((res) => {
              if (res.status == 200) {
                if(res.data.code){
                  this.$message.error(res.data.description);
                  return ;
                }
                this.cabinetDetailVisible = true;
                this.newReagentList = res.data;
              }
            });
        });
    },
    //打开编辑 数量
    openEditNum() {
      if (
        !(
          this.row != undefined &&
          this.column != undefined &&
          this.row != "" &&
          this.column != ""
        )
      ) {
        this.$message.error("请先选择位置");
        return;
      }
      
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          if(res.data.del){
            this.$message.error("该位置已被禁用，不能修改数量~")
            return ;
          }
          this.editNumDialog = true;
          this.lockerCabinetGrid = res.data;
          this.editNum = res.data.reagentTotalNum;
        });
    },

    // 修改数量 保存按钮
    saveEditNum() {
      this.placeCode =
        this.lockerCabinet.cabName +
        "（" +
        this.rowIndex +
        "," +
        this.columnIndex +
        "）";
      this.$apiFetch
        .post(`/cabinetGrid/getLockerCabinetGrid/`, {
          cabId: this.lockerCabinet.id,
          numX: this.rowIndex,
          numY: this.columnIndex,
        })
        .then((res) => {
          this.lockerCabinetGrid = res.data;
          let ids = [];
          ids.push(res.data.id);
          this.$apiFetch
            .post(`/cabinetGrid/editGridNumByIds/${this.editNum}`, ids)
            .then((res) => {
              if (res.status == 200) {
                if(res.data.code){
                  this.$message.error("该位置已被禁用，不能修改数量~")
                  return ;
                }
                this.$message.success("修改成功");
                this.getCurrentLocation();
                this.getCurrentLocationInit();
              } else {
                this.$message.success("修改失败");
              }
            });
          this.editNumDialog = false;
          this.editNum = "";
          this.editInputDisable = true;
        });
    },
    handleCellStyle(row, rowIndex, column) {
      if (this.row === row.row && this.column === row.column) {
        this.rowIndex = row.rowIndex + 1;
        this.columnIndex = row.columnIndex;
        return "background-color:#00b050;";
      } else {
        return "background-color:#fff;cursor:pointer;";
      }
    },

    handleCellClick(row, column, cell, event) {
      this.row = row; // 取个唯一值用作判定行
      this.column = column;
    },

     //    // 表头行
    indexMethod(index) {
      return "第" + (index + 1) + "行";
    },
    // 查询余数
    // 数据处理
    getNewData(data) {
      this.selectLocationList2 = [];
      for (let i = 1; i <= this.lockerCabinet.numX; i++) {
        this.selectLocationList2.push(data[`${i}`]);
      }
      console.log("new Data", this.selectLocationList2);
      this.dataColumn = this.selectLocationList2[0];
    },

    // 获取当前门禁中位置
    async getCurrentLocationInit() {
      const id = this.currentLocationId;
      const { data } = await this.$apiFetch.get(
        "/cabinetGrid/queryCabinetGridList2",
        { id }
      );
      if (!data.code) {
        this.getNewData(data);
      }
    },

    //批量选择位置按钮
    batchSelectLocation() {
      let flag = false;
      if (this.selections.length <= 0) {
        this.$message.warning("请先选择");
        flag = true;
      }
      try{
        this.selections.forEach((item) => {
          if (
              item.operation == "订购中" ||
              item.operation == "待入库" ||
              item.operation == "在库" ||
              item.operation == "已取出" ||
              item.operation == "待编辑" ||
              item.operation == "盘点遗失"

          ) {
            console.log(item.code);
          } else {
            flag = true;
            throw new Error("选中试剂中 - " + item.operation + " 状态下不能修改");
          }
        });
      }catch (e){
        this.$message.error(e.message)
        return ;
      }


      if (!flag) {
        this.dialogBind = true;
        this.getCabinetList(); // 获取柜机列表
      }
    },

    // 获取柜机
    getCabinetList() {
      this.$apiFetch.get(`/lockerCabinet/queryAvailableCabList`).then((res) => {
        console.log(res);
        this.canBindCab = res.data;
        // if (row.cabId) {
        //   this.cabId = row.cabId;
        // }
        // this.canBindCab.forEach((item) => {
        //   this.$set(item, "bindCartNum", 1);
        // });
      });
    },

    openDialogDetail(object) {
      // this.showProgessDialog(object);
      this.showExpressDialog(object);
    },

    // 订购中物流详情
    buyDetail(object){
      this.timeFlag = setTimeout(()=>{
        this.$apiFetch
            .get(`/lockerOrders/getOrderExpress/${object.orderId}`+'/'+object.orderItemsId)
            .then((data) => {
              if (data.data ) {
                this.orderInfo = data.data
              }
            })
            .catch((error) => {
              console.log(error);
            });
      },400)
    },

    buyDetailMouseLeve(){
      clearTimeout(this.timeFlag)
    },

    // 显示物流进度对话框
    async showProgessDialog(object) {
      // this.fullscreenLoading = true;
      this.$apiFetch
        .get("/lockerCas/supplierLogisticsList", { orderid: object.orderNo })
        .then((data) => {
          if (data.data && data.data.length > 0) {
            this.fullscreenLoading = false;

            this.progressInfo = data.data;
            this.progessVisible = true;
          } else {
            this.fullscreenLoading = false;
            this.$message.error("暂无相关物流信息~");
          }
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          console.log(error);
        });
    },
    //查询订单
    showExpressDialog(object) {
      this.fullscreenLoading = true;
      this.$apiFetch
          .get(`/lockerOrders/getOrderByOrderNo/${object.orderId}`)
          .then((data) => {
            if (data.data) {
              this.fullscreenLoading = false
              this.orderInfo = data.data
              if(data.data.orderStatus ==2 ){ // 已发货显示物流信息
                this.progessVisible = true
              }else{
                this.fullscreenLoading = false;
                this.$message.warning("暂无相关物流信息~");
              }

            } else {
              this.fullscreenLoading = false;
              this.$message.warning("暂无相关物流信息~");
            }
          })
          .catch((error) => {
            this.fullscreenLoading = false;
            console.log(error);
            this.$message.warning("暂无相关物流信息!");
          });
    },
    // 分页 size 改变
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.reagentList();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.reagentList();
    },

    searchReagentWeight() {},

    change1() {
      this.$refs.on.style.display = "block";
      this.$refs.off.style.display = "none";
      this.searchData.reagentRemainWeight = null;
      this.reagentList();
    },
    change2() {
      var flag = this.searchData.reagentRemainWeight;
      var flag1 = this.reagentRemainWeight_1;
      if(0 == flag1){
        this.$refs.on.style.background = "#ebb563";
        this.searchData.reagentRemainWeight = 1;
        this.reagentRemainWeight_1 = 1;
        this.$refs.on1.style.background = "#F0F0F0";
        this.reagentRemainWeight_10 = 0;
      }else {
        this.$refs.on.style.background = "#F0F0F0";
        this.reagentRemainWeight_1 = 0;
        this.searchData.reagentRemainWeight = null;
      }
      this.reagentList();
    },
    change3() {
      this.$refs.on1.style.display = "block";
      this.$refs.off1.style.display = "none";
      this.searchData.reagentRemainWeight = null;
      this.reagentList();
    },
    change4() {
      var flag = this.searchData.reagentRemainWeight;
      var flag1 = this.reagentRemainWeight_10;
      if(0 == flag1){
        this.$refs.on1.style.background = "#ebb563";
        this.$refs.on.style.background = "#F0F0F0";
        this.searchData.reagentRemainWeight = 10;
        this.reagentRemainWeight_10 = 1;
        this.reagentRemainWeight_1 = 0;
      }else {
        this.$refs.on1.style.background = "#F0F0F0";
        this.reagentRemainWeight_10 = 0;
        this.searchData.reagentRemainWeight = null;
      }
      this.reagentList();
      //
      //
      // this.$refs.on1.style.display = "none";
      // this.$refs.off1.style.display = "block";
      // this.$refs.on.style.display = "block";
      // this.$refs.off.style.display = "none";
      // this.searchData.reagentRemainWeight = 10;
      // this.reagentList();
      //
      // this.$refs.on1.style.display = "none";
      // this.$refs.off1.style.display = "block";
      // this.$refs.on.style.display = "block";
      // this.$refs.off.style.display = "none";
      // this.searchData.reagentRemainWeight = 10;
      // this.reagentList();
    },

    //下载按钮
    handleDownloadTemplate() {
      const resp = this.$apiFetch
          .download("/lockerReagentFree/downTemplate")
          .then((resp) => this.downloadFile(resp,'LawkeyReagentTemplateFree'));
    },

    handleDelete() {
      if (this.selections.length == 0) {
        this.$message.warning("请选择需要删除的数据");
        return;
      }
      let ids = [];
      ids = this.selections.map((i) => i.id);
      this.$confirm(
        "该操作将删除试剂在柜机内数据，删除后将无法恢复，确认删除?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$apiFetch.post(`/lockerReagentFree/deleteBatch`, ids).then((res) => {
          if (!res.data.code) {
            this.$message.success("批量删除成功");
            this.reagentList();
          } else {
            this.$message.error(res.data.description);
          }
        });
      });
    },

    async handlePrint() {
      if (this.selections.length == 0) {
        this.$message.warning("请选择需要打印的数据");
        return;
      }
      let ids = [];
      ids = this.selections.map((i) => i.id);
      let status = [];
      status = this.selections.map((i) => i.operation);
      for (let i = 0; i < status.length; i++) {
          // if("待编辑" == status[i] || "在库" == status[i] || "盘点中" == status[i] || "盘点遗失" == status[i]){
          if("待编辑" == status[i]){
            this.$message.warning("当前试剂的状态不符合,请检查");
            return;
          }
      }
      // const res = await this.$apiFetch.post("/lockerReagent/printAll", ids);
      // this.printData = res.data;
      // this.printListDiag = true;
      this.$apiFetch.post("/lockerReagentFree/printAll", ids)
          .then((res) => {
            if(!res.data.code){
              this.printData = res.data;
              this.printListDiag = true;
            }
          })
          .catch((error)=>{
      });
    },

    handleExportLockerReagent() {
      var radio = this.downloadform.radio;
      //如果等于1，代表是部分导出
      if("1" == radio){
        if (this.selections.length == 0) {
          this.$message.warning("请选择需要导出的数据");
          return;
        }
        let ids = [];
        ids = this.selections.map((i) => i.id);
        const resp = this.$apiFetch
          .download("/lockerReagentFree/exportExecl", ids)
          .then((resp) => this.downloadFile(resp,this.taskName+'试剂列表'));
        this.exportToastVisible = false;
      }
      //如果等于2，代表是有关这个课题组的数据全部导出
      if("2" == radio){
        const resp = this.$apiFetch
            .download("/lockerReagentFree/exportExeclAll")
            .then((resp) => this.downloadFile(resp,this.taskName+'试剂列表'));
        this.exportToastVisible = false;
      }
    },

    //导出下载弹框
    handleExport() {
      this.downloadform.radio = '1';
      this.exportToastVisible = true;
    },

    handleSelectionChange(val) {
      this.selections = val;

      let checkedCount = val.length;
      this.checkAll = checkedCount === this.reagenData.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.reagenData.length;
    },

    // 单位
    unit(reagentWeightUnit) {
      //单位适配
      return reagentWeightUnit == 1
        ? "mL"
        : reagentWeightUnit == 2
        ? "g"
        : reagentWeightUnit == 7
        ? "U"
        : reagentWeightUnit == 6
        ? "KU"
        : reagentWeightUnit == 5
        ? "kg"
        : reagentWeightUnit == 3
        ? "mg"
        : reagentWeightUnit == 4
        ? "L"
        : "";
    },

    openLoading(){
      this.itemLoding = this.$loading({
          lock:true,
          text:"正在加载",
          spinner:"el-icon-loading",
          background:"#f5f7fac4",
          target:document.querySelector("#itemId")
      })
    },
    closeLoading(){
      this.itemLoding.close();
    },
    //试剂柜列表
    async reagentList(searchLogFlag) {
      let params = this.searchData;
      params.operation = this.selectValue;
      this.isLoading = true;
      this.openLoading()
      this.$apiFetch
        .get("/lockerReagentFree/queryReagentById", params)
        .then((res) => {
          res.data.list.map((item) => {
            // if (!item.operation) {
            //   item.operation = "-";
            // }

            // if (item.cabType == 1) {
            //   item.cabType = "智能柜";
            // } else if (item.cabType == 2) {
            //   item.cabType = "门禁柜";
            // }
            if (item.operation == 8) {
              item.operation = "订购中";
            } else if (item.operation == 1) {
              item.operation = "待入库";
            } else if (item.operation == 2) {
              item.operation = "在库";
            } else if (item.operation == 3) {
              // item.operation = "已借出";
              item.operation = "已申领";
            } else if (item.operation == 4) {
              item.operation = "已取出";
            } else if (item.operation == 5) {
              item.operation = "移除中";
            } else if (item.operation == 6) {
              item.operation = "移除成功";
            } else if (item.operation == 7) {
              item.operation = "转用中";
            } else if (item.operation == 0) {
              item.operation = "待编辑";
            } else if (item.operation == 9) {
              item.operation = "盘点中";
            }else if (item.operation == 10) {
              item.operation = "盘点遗失";
            }else {
              item.operation = "-";
            }
            item.reagentWeight=parseFloat(item.reagentWeight);
            item.reagentRemainWeight=parseFloat(item.reagentRemainWeight);
          });
          this.reagenData = res.data.list;
          this.totalpage = res.data.pages;
          this.dataTotal = res.data.total;
        this.closeLoading();
        }).catch((res)=>{
          this.closeLoading();
        })


      this.getChooseData();
      this.getBookingData();
      this.isLoading = false;

      if(searchLogFlag===true){
        console.log("params = ",params)
        this.addSearchLog(params);
      }
    },
    // 添加搜索记录到库中
    addSearchLog(params){
      let content = ""
      if(params.casNo){
        content = content + params.casNo.trim() + " | "
      }
      if(params.operation){
        let operationArr = ['待编辑','待入库','在库','已申领','已取出','移除中','移除成功','转用中','订购中','盘点中','盘点遗失',]
        if(params.operation>=0 && params.operation<=10){
          content += operationArr[params.operation]+ " | "
        }
      }
      if(params.originalLocation ){
        content += params.originalLocation.trim()+ " | "
      }
      if(!content){
        console.log("空白内容")
        return ;
      }
      if(content.lastIndexOf(" | ")){
        content = content.slice(0,-3)
      }
      try{
        this.$apiFetch
            .post(`/searchLog/add`,{searchContent:content,logType: 2})
            .then(function (res) {
              if(res.data){
                console.log("搜索记录添加成功.",res.data)
              }
            });
      }catch (e) {
        console.log(e)
      }
    },
    //展示试剂详情
    async showDeail(row) {
      this.curbottleCodeObjDiv = row;

      if(row.orderItemsId){
        let result = await this.getOrderItemById(row.orderItemsId)
        if(result.discountAmount && result.discountAmount!=0.0){
          if(result.isSpecial){
            this.curbottleCodeObjDiv.salesPriceTask = result.salesPrice;
          }else{
            this.curbottleCodeObjDiv.salesPriceTask = Math.floor(result.salesPrice*result.discountAmount*100)/100
          }
        }else{
          if(result.salesPriceTask){
            this.curbottleCodeObjDiv.salesPriceTask = result.salesPriceTask;
          }else{
            this.curbottleCodeObjDiv.salesPriceTask = result.salesPrice+""
          }
        }
      }

      this.dialogCreateDiv = true;

      this.curbottleCodeObjDiv.structionImg = row.structImgUrl
      // let result = await this.getStructImg(row.casNo)
      // console.log(result)
      // if(result){
      //   if(result.structure){
      //     this.curbottleCodeObjDiv.structionImg = result.structure
      //   }
      // }
    },
    // 获取结构式 图片
    async getStructImg(cas){
      if(!cas) return
      const resultData = await this.$apiFetch.get('/lockerCas/info',{alias:cas}).catch((e)=>{console.log("本地库没有该cas")} );
      if(!resultData){
        return null;
      }
      return resultData.data
    },
    // 获取订单item 详情
    async getOrderItemById(itemId){
      let data = null
      if(!itemId) return
      await this.$apiFetch.get(`/lockerOrdersItems/byId/${itemId}`).then((res) => {
        data =  res.data
      });
      return data
    },
    //移除试剂
    delReagentByOrder(row) {
      this.$confirm("该操作不能移除订单下的待入库试剂", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      });
    },
    //移除试剂
    delReagent(row) {
      let id = row.id;
      const that = this;
      this.$confirm(
        "该操作将删除试剂在柜机内数据，删除后将无法恢复，确认删除?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$apiFetch.delete(`/lockerReagentFree/${id}`).then((res) => {
            if (!res.data.code) {
              this.$message.success("移除成功");
              that.reagentList();
            } else {
              this.$message.error(res.data.description);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      // this.$apiFetch.delete(`/lockerReagent/${id}`).then(() => {
      //   this.reagentList();
      // });
    },
    //取消移除
    undelReagent(row) {
      let id = row.id;
      const that = this;
      this.$confirm("确认取消移除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$apiFetch
            .get(`/lockerReagentFree/unTakeReagent`, { id })
            .then((res) => {
              if (!res.data.code) {
                this.$message.success("取消移除成功");
                that.reagentList();
              } else {
                this.$message.error(res.data.description);
              }
            });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    //打开瓶身码弹框
    createCode(row) {

      this.codeData = row;

      let id = row.id;
      let params = {
        id,
      };
      this.$apiFetch
        .post(`/lockerReagentFree/selectBottleCode`, params)
        .then((res) => {
          if (res.data.id) {
            this.dialogCreate = true;
            this.curbottleCodeObj = res.data;
            this.curbottleCode = "data:image/png;base64," + res.data.codeImg;
          }
          // this.cabGridx = res.data.cabGridx;
          // this.cabGridy = res.data.cabGridy;
        }).catch((error)=> {
      });
    },

    //可用柜机
    usableCabinet(row) {
      this.changeId = row.id;
      this.dialogBind = true;
      this.$apiFetch.get(`/lockerCabinet/queryAvailableCabList`).then((res) => {
        console.log(res);
        this.canBindCab = res.data;
        if (row.cabId) {
          this.cabId = row.cabId;
        }
        this.canBindCab.forEach((item) => {
          this.$set(item, "bindCartNum", 1);
        });
      });
    },
    handleChange() {},
    //位置码
    placeCode(row) {
      if (!row.cabCoords) {
        this.$message.error("当前试剂尚未存入");
        return;
      }
      let id = row.id;
      let params = {
        id,
      };
      this.$apiFetch
        .post(`/lockerReagentFree/selectLocationCode`, params)
        .then((res) => {
          if (!res.data.code) {
            this.dialogPlace = true;
            this.curLocationCodeObj = res.data;
            this.curLocationCodeObj.cabGridx = row.cabCoords.split(",")[0];
            this.curLocationCodeObj.cabGridy = row.cabCoords.split(",")[1];
            this.curLocationCode = "data:image/png;base64," + res.data.codeImg;
          } else {
            this.$message.error(res.data.description);
          }
          // this.cabGridx = res.data.cabGridx;
          // this.cabGridy = res.data.cabGridy;
        });
    },
    // toAddReagent() {
    //   // this.$router.push("/addReagent");
    //   this.$router.push({ path: "addReagent", query: { name: "新增试剂" } });
    // },
    //绑定柜机
    bindCabinet() {
      // debugger;
      // const num = this.canBindCab.find(item=>item.id == this.cabId).bindCartNum
      // let params = {
      //   id: this.cabId,
      //   num,
      //   reagentId: this.changeId,
      // };
      const params = {
        cabId: this.cabId,
        id: this.changeId,
      };
      if (!params.cabId || !params.id) {
        this.$message.error("请选择正确柜机后提交");
      }

      if (this.cabType == 2) {
        if (!this.gridId || !this.numX || !this.numY) {
          this.$message.error("请选择门禁柜绑定位置");
          return;
        }
        params.gridId = this.gridId;
        params.numX = this.numX;
        params.numY = this.numY;
      }

      this.$apiFetch.put(`/lockerReagent`, params).then((res) => {
        if (!res.data.code) {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.dialogBind = false;
          this.reagentList();
        } else {
          this.dialogBind = false;
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        }
      });
    },
    searchCabs() {
      this.$apiFetch
        .get(`/lockerCabinet/queryAvailableCabList`, { cabName: this.cabName })
        .then((res) => {
          this.canBindCab = res.data;
        });
    },

    httpRequest(e) {
        let _this = this;
        var rABS = false; //是否将文件读取为二进制字符串
        let f = e.file; // 文件信息
        if (!f) return false;
        else if (!/\.(xls|xlsx)$/.test(f.name.toLowerCase())) {
          this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
          return false;
        }
      var param = new FormData();
      //将文件append到formData对象
      param.append("file", f);
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$apiFetch.post('/lockerReagentFree/importData', param).then((res) => {
        loading.close();
        if (!res.data.code) {
          _this.$message.success("导入成功");
          _this.reagentList();
        } else {
          _this.$message.error("导入失败 -- " + res.data.description);
        }
      }).catch((error)=> {
        loading.close();
      });
    },
    fixdata(data) {
      var o = "",
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.reagentList();
    },
    //编辑柜机
    editCabinet(info) {
      console.log(info);
      localStorage.setItem("currentEditReagent", JSON.stringify(info));
      // this.$router.push({ path: "addReagent", query: { name: '修改试剂信息' }, });
      this.$router.push({
        name: "addReagentFree",
        params: { type: 2, operation: info.operation },
        query: { name: "修改试剂信息" },
      });
    },
    //手动确认入库成功
    putInSuccess(info) {
      console.log(info);
      const { id } = info;
      const that = this;
      this.$confirm("是否确认入库?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$apiFetch.get(
            "/lockerReagentFree/reagentWarehous",
            { id }
          );
          if (!res.data.code) {
            this.$message.success("入库成功");
            that.reagentList();
          } else {
            this.$message.error(res.data.description);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    //手动确认取出成功
    async putOutSuccess(info) {
      console.log(info);
      const { id } = info;
      const that = this;
      this.$confirm("是否确认取出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$apiFetch.get("/lockerReagentFree/takeReagent", {
            id,
          });
          if (!res.data.code) {
            this.$message.success("取出成功");
            that.reagentList();
          } else {
            this.$message.error(res.data.description);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    //选择柜机 查看位置列表
    onSelectCabinet(data) {
      // debugger;
      this.currentLocationId = data.id;
      this.cabType = 2;
      this.dialogSelect = true;
      this.getCurrentLocation();
    },
     //获取当前门禁中位置
     async getCurrentLocation() {
      const { currentLocationId } = this;
      const { data } = await this.$apiFetch.get("/lockerCabinet/getCabinet", {
        id: currentLocationId,
      });
      this.lockerCabinet = data;
    },
    onSelectLocation(data) {
      this.cabId = this.currentLocationId;
      this.gridId = data.id;
      this.numX = data.numX;
      this.numY = data.numY;
      this.$message.success("选择成功！");
      this.dialogSelect = false;
    },
    locationChangePage(data) {
      this.locationSearchData.pageNum = data;
      this.getCurrentLocation();
    },
    onRadioChange(item) {
      // debugger;
      console.log(item);
      if (item.cabType == 2) { // 门禁柜
        this.currentLocationId = item.id;
        this.dialogSelect = true;
        this.getCurrentLocation();
        this.getCurrentLocationInit()
      }else if(item.cabType == 1){// 智能柜
        this.currentLocationId = item.id
        this.dialogBind = false;
        //在这里也进行区分，chooseFlag为1时，代表试剂管理页面进行选择数据，2时为预选页面进行数据选择
        let tempReagentIdArr;
        if(1 == this.chooseFlag){
          tempReagentIdArr = this.selections.map((item, index) => {
            return item.id;
          });
        }else if(2 == this.chooseFlag){
          tempReagentIdArr = [this.confirmData.id];
        }else {
          tempReagentIdArr = this.chooseSelections.map((i) => i.reagentId);
        }
        this.updateReagentCabinet(tempReagentIdArr,1,this.currentLocationId,null)
      }
      // this.onSelectCabinet(item);
    },

    //加入预选
    addChoose(row){
      const reagentId = row.id;
      this.chooseIds[0] = reagentId;
      //this.chooseIds = this.selections.map((i) => i.id);
      //console.log(this.chooseIds);
      this.$apiFetch.post('/reagentPreselection/addPreselection', this.chooseIds).then((res) => {
        if (!res.data.code) {
          this.$message.success("加入预选成功");
          this.reagentList();
        } else {
          this.$message.error("加入预选失败 -- " + res.data.description);
        }
      }).catch((error)=> {
      });

    },
    chooseDataList(){
      this.$apiFetch.get('/reagentPreselection/getChoose', null).then((res) => {
        if (!res.data.code) {
          this.chooseGridData = res.data;
        }
      }).catch((error)=> {
      });
    },
    bookingClick(){
      this.$router.push({ path: "borrowInfoFree",query:{type:"reagentRunFree"} });
    },
    chooseDialog(){
      this.chooseTable = true;
      this.chooseDataList();
      this.chooseFlag = 3;
    },

    cancelChooseTable(){
      this.chooseGridData = null;
      this.chooseTable = false;
      this.chooseFlag = 1;
    },
    delChoose(){
      var val = this.chooseSelections.map((i) => i.id);
      if(null == val || val.length <= 0){
        this.$message.warning("请选择数据");
        return
      }
      this.$apiFetch.post('/reagentPreselection/delPreselection', val).then((res) => {
        if (!res.data.code) {
          this.chooseDataList();
          this.reagentList();
        }
      }).catch((error)=> {
      });
    },
    chooseSelectHandler(val){
      this.chooseSelections = val;
    },
    choosePosition(){
      var val = this.chooseSelections.map((i) => i.id);
      if(null == val || val.length <= 0){
        this.$message.warning("请选择数据");
        return
      }
      this.chooseFlag = 3;
      this.dialogBind = true;
      this.getCabinetList(); // 获取柜机列表

    },
    queryMatchCab(queryString, cb) {
      if(""==queryString || '2' == this.searchData.locationType){
        cb([]);
        return;
      }
      this.$apiFetch.get('/cabinetGrid/getScanCab/'+queryString).then((res) => {
        cb(res.data);
      }).catch((error)=> {
      });
    },
    handleCabSelect(item){
      //this.$refs.cabAutoRef.focus();
    },
    setBlur(){
      document.activeElement.blur();
    },
    confirmReceived(row) {
      let id = row.id;
      if(null == row.cabType){
        this.chooseFlag = 2
        this.$confirm('确认收货前需要绑定位置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confirmData = row;
          this.dialogBind = true;
          this.getCabinetList(); // 获取柜机列表
        }).catch(() => {
        });
      }else {
        this.$confirm('是否确认收货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$apiFetch.get('/lockerOrders/confirmReceipt1/'+id).then(() => {
            this.reagentList();
          });
        }).catch(() => {
        });
      }
    },
    //代码逻辑嵌套调用确认收货
    confirmReceivedById(id) {
      this.$apiFetch.get('/lockerOrders/confirmReceipt1/'+id).then(() => {
        this.reagentList();
      });
    },
    iconWarn(){
      this.iconWarnDialog = true;
    },
    iconWarnDialogClose(){
      this.iconWarnDialog = false;
    }
  },
  filters: {
    rounding(value) {
      return value.toFixed(2);
    },
    numFilter (value) {
      // 截取当前数据到小数点后三位
      return Math.floor(value*1000)/1000;
    },
  },
};
</script>
<style>
.zoom-in{
  cursor: zoom-in
}
.locationClass .input-with-select .el-input-group__prepend {
  background-color: #fff;
  padding-left: 1px;
}
.locationClass .el-input__inner {
  width: 180px;
  padding-left: 10px;
}
.el-drawer__body{
  padding: 20px;
}
.zZindex {
  z-index:3000 !important;
}


.locationClass .el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner{
  width: 110px;
}
</style>
<style lang="less" scoped>
.reagentTextOverflow{
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.clearfix .downloadBtn {
  position:fixed;
  right:200px;
}
.uploadBtn {
  position:fixed;
  right:70px;
}
.btnWrapper {
      text-align: right;
      .el-button--default {
        border: 1px solid #dcdfe6 !important;
        &:hover {
          color: #409eff !important;
          border-color: #c6e2ff !important;
          background-color: #ecf5ff;
        }
      }
    }
.el-form-item {
  margin-bottom: 0px;
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      float: left;
      // width: 80%;
      position: relative;
      // img {
      //   width: 14px;
      //   display: block;
      //   position: absolute;
      //   top: 11px;
      //   left: 9px;
      // }
      input {
        width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 10px;
      }
      //button {
      //  width: 98px;
      //  height: 36px;
      //  //background: #478aff;
      //  border-radius: 4px;
      //  font-size: 12px;
      //  color: #ffffff;
      //
      //}
    }
    li.last {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      button {
        min-width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 4px;
        font-size: 13px;
      }
      .download {
        min-width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 4px;
        font-size: 13px;
        border: 1px solid #478aff;
        color: #478aff;
        background-color: #ffffff;
      }
      button.leading {
        background: #478aff;
        color: #ffffff;
      }

      .el-button {
        padding: 0;
      }
    }
  }
}
.placeDia {
  ul {
    margin-bottom: 20px;
    li {
      padding-top: 20px;
      label {
        display: block;
        color: #666666;
        font-size: 14px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }
    }
    li:first-child {
      padding-top: 0;
    }
  }
  .locking {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #478aff;
    border-radius: 4px;
    border: 1px solid #478aff;
    background-color: #ffffff;
    margin-top: 25px;
  }
  span.tips {
    color: #ff4d4f;
    padding-top: 6px;
    text-align: center;
    display: block;
  }
}
.searchName {
  input {
    width: 434px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    padding-left: 9px;
  }
  button {
    width: 98px;
    height: 36px;
    margin-left: 12px;
    vertical-align: bottom;
  }
}
.bindDia {
  p {
    padding-top: 25px;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      background-color: #fafafa;
      border-radius: 4px;
      height: 48px;
      margin-top: 8px;
      padding: 0 12px;

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #333333;
        font-size: 14px;
      }
      /deep/ .el-radio {
        margin-right: 8px;
      }
      /deep/ .el-radio__label {
        color: #333333;
        font-size: 14px;
      }

      .centerbox {
        width: 300px;
        display: flex;
        align-items: center;
      }

      .cabinet-type {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: #eaf1fc;
        border-radius: 4px;
        color: #478aff;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }
      .cabinet-type2 {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: rgba(250, 140, 22, 0.08);
        border-radius: 4px;
        color: #fa8c16;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }
      .remnant {
        padding-right: 10px;
        i {
          color: #081020;
        }
      }

      .chooseText {
        margin-left: 5px;
        font-size: 14px;
        color: #478aff;
        line-height: 20px;
        cursor: pointer;
      }

      /deep/.el-input-number__decrease {
        border-right: 1px solid #e9e9e9;
        background-color: #fafafa;
        .el-icon-minus {
          color: #979797;
          font-weight: 700;
        }
      }
      /deep/ .el-input-number__increase {
        border-left: 1px solid #e9e9e9;
        background-color: #fafafa;
      }
      /deep/.el-input__inner {
        border: 1px solid #e9e9e9;
        color: #333333;
        font-weight: 700;
      }
    }
  }
}
.createDia {
  .code {
    // width: 410px;
    // height: 195px;
    background: #f2f5fa;
    border-radius: 4px;
    padding: 15px;
    display: flex;
    // align-items: center;
  }
  .codeInfo {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 25px;
    color: #333333;
    justify-content: space-between;
  }
  .codeAddress {
    font-size: 14px;
    color: #333333;
    line-height: 25px;
  }
  // .codeImg {
  //   width: 100%;
  //   height: 115px;
  // }
  .info {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .infoText {
      margin-top: 5px;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
}
.supTable {
  img {
    width: 100px;
    height: 100px;
  }
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}

.addressBox {
  margin-top: 7px;
  display: flex;
  // margin-top: 20px;

  img {
    width: 100px;
    height: 100px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .infoText {
      margin-top: 5px;
      color: #000;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}

.addressBox1 {
  margin-top: 7px;
  display: flex;
  // margin-top: 20px;

  img {
    width: 100px;
    height: 100px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .infoText {
      margin-top: 5px;
      color: #000;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
    .infoText-bottom {
      padding-top: 5px;
      color: #000;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }

  }
}
/deep/.searchLine {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;

  .searchIcon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
  }

  //.el-input {
  //  width: 380px;
  //}

  .el-input__inner {
    height: 36px;
  }

  //button {
  //  margin-left: 12px;
  //  width: 98px;
  //  height: 36px;
  //  border-radius: 4px;
  //  line-height: 1;
  //  text-align: center;
  //  //background: #478aff;

  //  font-size: 13px;
  //  color: #ffffff;
  //}
  .locationClass {
    .input-with-select {
      padding-left: 10px;
    }
    .el-select {
      .el-input {
        width: 100px;
      }
    }
  }
  .el-select {
    margin-left: 40px;

    .el-input {
      width: 110px;
    }
  }

  .settingBox {
    margin-left: 56px;
    //display: inline-flexbox;

    .oneLine {
      display: flex;
      align-items: center;

      .beforeText {
        font-size: 13px;
        color: #333333;
        height: 24px;
        line-height: 24px;
      }

      img {
        display: inline-block;
        margin-left: 12px;
        width: 40px;
        height: 24px;
        cursor: pointer;
      }

      .afterText {
        margin-left: 9px;
        font-size: 11px;
        color: #999999;
        height: 24px;
        line-height: 24px;
      }
    }

    .twoLine {
      height: 24px;
      font-size: 11px;
      color: #999999;
      line-height: 24px;
    }
  }
}
.text-overflow {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏
}
/deep/.openDialog {
  .el-dialog__body {
    padding-top: 0;
  }
  .openTitle {
    height: 28px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
  }
  .openText {
    height: 24px;
    font-size: 16px;
    color: #999999;
    line-height: 24px;
  }

  .openBtnLine {
    margin-top: 30px;
    display: flex;
    align-items: center;

    button {
      width: 175px;
      height: 36px;
      background: #f8fafc;
      border-radius: 18px;
      color: #666666;
      cursor: pointer;

      &.active {
        color: #fff;
        background: #478aff;
      }

      &:last-of-type {
        margin-left: 24px;
      }
    }
  }
}

.selectLocationBox {
  .el-table {
    border: 1px solid #e8e8e8;

    .el-table thead {
      background-color: #f8fafc;
      color: rgba(0, 0, 0, 0.85);
    }

    .selectText {
      height: 21px;
      font-size: 14px;
      color: #478aff;
      line-height: 21px;
      cursor: pointer;
    }
  }
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  width: 10px;
  height: 10px;
  background-color: #478aff;
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: unset;
  border-color: #409eff;
}

/deep/.all-cabinet {
  .el-radio {
    display: flex;
    align-items: center;
  }

  .el-radio__input {
    display: flex;
    align-items: center;
  }

  .el-radio__label {
    display: flex;
    align-items: center;
  }
}
.search-btn {
  width: 151px;
  margin-left: 32px;
  height: 54px;
  background: #478aff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 22px;
}
// .basic-btn{
// text-align: center;
// width:110px;
// font-size: 12px;
// font-weight: 500;
// color:#fff;
// }
ul li {
  list-style: none;
  font-size: 1rem;
}
ul {
  padding-left: 1.5rem;
}
.track-list {
  position: relative;
}
ul li {
  list-style: none;
  font-size: 1rem;
}
ul {
  padding-left: 1.5rem;
}
.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}
.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}
.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}
.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}
.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}
.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}
.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}
.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}
.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}
.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}
.borrowDia {
  ul {
    li {
      padding-top: 20px;
      label {
        display: block;
        color: #666666;
        font-size: 14px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }
      .tips {
        font-size: 12px;
        line-height: 18px;
        color: #999999;
        padding-top: 6px;
        display: block;
      }
    }
    li:first-child {
      padding-top: 0;
    }
    li:last-child {
      input {
        border-bottom: 1px dashed #cccccc;
      }
    }
  }
}

.tabelBl{
  border-left: 1px solid #E8E8E8;
}

.tabelBTr{
  border-top: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
}

.tableLeftTextBox{
  height: 100%;
  min-height: 55px;
  padding-left: 20px;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;

}

.tableRightTextBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  font-weight: 700;
  padding: 0 20px;
}
.tableImagesBox{
  min-height: 55px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.tableBB{
  border-bottom: 1px solid #E8E8E8;
}
.wx_btn{
  color: #443e31;
  padding: 2px 4px;
  border-radius: 50%; /* 椭圆形 */
  background-color: #f4b824; /* 背景颜色 */
  text-align: center;
  text-decoration: none;
  font-size: 12px;
}
.check-box-list{
  width: 50%;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

